import React from 'react';
import { useLocation } from 'react-router-dom';

import { NavMenu, NavMenuItem } from '../../../components/nav-menu';

type MenuOptions = {
  key: string;
  label: string;
  href: string;
};

type SpaceSettingsMenuProps = {
  items: MenuOptions[];
};

export const SettingsMenu: React.FC<SpaceSettingsMenuProps> = ({ items }) => {
  const location = useLocation() as { state: { prevPath: string } };
  const pathname = window.location.pathname.split('/');

  return (
    <NavMenu>
      {items.map(({ key, label, href }) => (
        <NavMenuItem
          key={key}
          to={href}
          label={label}
          state={location.state}
          isActive={(pathname.length === 4 && key === 'general') || pathname.includes(key)}
        />
      ))}
    </NavMenu>
  );
};
